<template>
  <div :id="subSection.id"
       class="pdf-preview-sub-sub-section-header content-row">
    <div class="item-no left flat"></div>
    <div class="sub-sub-section-header">
      <div class="sub-sub-section-descriptions"
           v-if="subSubSection.descriptions"
           v-html="replaceItemNo(subSubSection.descriptions)"></div>
      <div class="sub-sub-section-unit"><i>{{ subSubSection.unit }}</i></div>
    </div>
    <div v-for="suffix in categorySuffix(itemCategories)"
         :key="suffix"
         :class="[showCategories ? 'category' : 'item-price',]">
      <div v-if="showCategories">{{ suffix }}</div>
      <div v-if="showCategories">$</div>
    </div>
    <div class="item-no right flat"></div>
  </div>
</template>

<script>

export default {
  name: 'SubSubSectionHeader',
  props: {
    section: Object,
    subSection: Object,
    subSubSection: Object,
    showCategories: Boolean,
    itemCategories: Array,
  },
  setup(props) {
    const replaceItemNo = function (str) {
      return str.replaceAll(/({{[0-9]+}})/g, (match) => {
        let withoutBrackets = match.replace('{{', '').replace('}}', '')

        return `${props.section.order_no.toString().padStart(2, '0')}${withoutBrackets.padStart(3, '0')}`
      })
    };

    const categorySuffix = function (categories) {
      let category_suffix = categories.map((category) => category.suffix);

      if (category_suffix.length === 0) {
        category_suffix = ['A']
      }

      return category_suffix;
    }


    return {
      replaceItemNo,
      categorySuffix,
    }
  }
}
</script>
